var _defineProperty = require("/codebuild/output/src3720/src/s3/01/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _require = require('libphonenumber-js/max'),
  parsePhoneNumber = _require.parsePhoneNumber,
  ParseError = _require.ParseError;
var countryCodes = require('./utils/country-codes');
var _require2 = require('./shared-constants'),
  VALID = _require2.VALID,
  INVALID = _require2.INVALID;
var PARSE_ERROR_TYPE = {
  INVALID_COUNTRY: 'Invalid Country',
  NOT_A_NUMBER: 'Not a valid phone number',
  TOO_LONG: 'Phone number is too long',
  TOO_SHORT: 'Phone number is too short'
};
var CONSTANTS = {
  VALID: VALID,
  INVALID: INVALID
};
var PHONE_TYPES = {
  MOBILE: 'MOBILE',
  FIXED_LINE: 'FIXED_LINE',
  FIXED_LINE_OR_MOBILE: 'FIXED_LINE_OR_MOBILE',
  OTHER: 'OTHER'
};
var parse = function parse(phoneNumber, defaultCountryCode) {
  var parseFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'E.164';
  var result = {
    valid: INVALID,
    phone: null,
    countryCode: null,
    phoneType: null,
    error: {
      type: 'genericError',
      message: "Invalid phone number: ".concat(phoneNumber)
    }
  };
  if (!phoneNumber || !String(phoneNumber || '').trim()) {
    result.error.type = 'length';
    result.error.message = 'Empty invalid phoneNumber';
    return result;
  }
  try {
    result.countryCode = countryCodes.getCountryCode(phoneNumber) || defaultCountryCode;
    var phone = parsePhoneNumber(phoneNumber, result.countryCode.toUpperCase());
    if (!phone.isPossible()) {
      result.error = {
        type: 'impossibleNumber',
        message: 'Impossible phone number'
      };
      return result;
    }
    if (!phone.isValid()) {
      result.error = {
        type: 'invalidPhoneNumber',
        message: 'Invalid phone number'
      };
      return result;
    }
    return {
      valid: VALID,
      phone: parseFormat === 'NATIONAL_SHORT' ? phone.format('NATIONAL').replace(/[^0-9]/g, '') : phone.format(parseFormat),
      countryCode: result.countryCode,
      phoneType: PHONE_TYPES[phone.getType()] || PHONE_TYPES.OTHER,
      error: {
        type: null,
        message: null
      }
    };
  } catch (err) {
    if (err instanceof ParseError) {
      result.valid = INVALID;
      result.error = {
        type: 'parseError',
        message: PARSE_ERROR_TYPE[err.message]
      };
    } else {
      result.valid = INVALID;
    }
    return result;
  }
};
module.exports = _objectSpread({
  parse: parse,
  PHONE_TYPES: PHONE_TYPES
}, CONSTANTS);